import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useMemo } from 'react';
import { NavMarker } from 'react-rhumb';
import { useLocation, useParams } from 'react-router-dom';
import { useQuery } from 'data-fetching-client';
import ModuleDetailsResponse from 'marketplace-ui-assets-core/details/records/ModuleDetailsResponse'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ecos... Remove this comment to see the full error message

import HSPageViewTracker from 'ecosystem-marketplace-core/components/tracking/HSPageViewTracker';
import * as RequestState from 'ecosystem-marketplace-core/constants/RequestState';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/requestStates/RequestStateUtils';
import DocumentHead from 'ecosystem-marketplace-core/components/portals/DocumentHead';
import MetaRobots from 'ecosystem-marketplace-core/components/elements/MetaRobots';
import PrerenderReady from 'ecosystem-marketplace-core/components/prerender/PrerenderReady';
import PrerenderStatusCode from 'ecosystem-marketplace-core/components/prerender/PrerenderStatusCode';
import { GET_MODULE_DETAILS } from '../queries/moduleDetailsQuery';
import { PublicAppContext } from '../../selectors/app';
import { getRootUrl } from '../../utils/urls';
import ModuleDetailsPage from '../components/ModuleDetailsPage';
import NotFoundError from '../../components/error/NotFoundError';
import NoAccessError from '../../components/error/NoAccessError'; // @ts-expect-error untyped dependency

import GenericError from '../../components/error/GenericError';
import StorefrontUsageTrackerProvider from '../../context/StorefrontUsageTrackerProvider';

const ModuleDetailsError = ({
  children
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx(PublicAppContext, {
    children: /*#__PURE__*/_jsxs(DocumentHead, {
      children: [/*#__PURE__*/_jsx(MetaRobots, {
        directive: ['nofollow', 'noindex']
      }), /*#__PURE__*/_jsx(PrerenderReady, {}), /*#__PURE__*/_jsx(PrerenderStatusCode, {
        statusCode: 404
      })]
    })
  }), children]
});

export default function ModuleDetailsContainer() {
  const {
    pathname
  } = useLocation();
  const {
    slug
  } = useParams();
  const {
    loading,
    error,
    data,
    previousData
  } = useQuery(GET_MODULE_DETAILS, {
    variables: {
      slug
    }
  });
  const moduleDetails = useMemo(() => {
    const moduleDetailsData = data || previousData;
    return new ModuleDetailsResponse(moduleDetailsData ? moduleDetailsData.details : undefined);
  }, [data, previousData]);
  const requestState = getDataFetchingClientRequestState(error, loading);

  const getErrorState = errorState => {
    if (errorState && errorState.networkError && errorState.networkError.statusCode) {
      if (errorState.networkError.statusCode === 403) {
        return 403;
      } else if (errorState.networkError.statusCode === 404) {
        return 404;
      }
    }

    return null;
  };

  if (error) {
    switch (getErrorState(error)) {
      case 403:
        {
          return /*#__PURE__*/_jsx(ModuleDetailsError, {
            children: /*#__PURE__*/_jsx(NavMarker, {
              name: "MODULE_DETAILS_403_LOAD",
              children: /*#__PURE__*/_jsx(NoAccessError, {})
            })
          });
        }

      case 404:
        {
          return /*#__PURE__*/_jsx(ModuleDetailsError, {
            children: /*#__PURE__*/_jsx(NavMarker, {
              name: "MODULE_DETAILS_404_LOAD",
              children: /*#__PURE__*/_jsx(NotFoundError, {})
            })
          });
        }

      default:
        {
          return /*#__PURE__*/_jsx(ModuleDetailsError, {
            children: /*#__PURE__*/_jsx(NavMarker, {
              name: "MODULE_DETAILS_ERROR_LOAD",
              children: /*#__PURE__*/_jsx(GenericError, {})
            })
          });
        }
    }
  }

  return /*#__PURE__*/_jsxs(StorefrontUsageTrackerProvider, {
    children: [requestState === RequestState.SUCCEEDED ? /*#__PURE__*/_jsx(ModuleDetailsPage, {
      moduleDetails: moduleDetails
    }, `module-details-${slug}`) : null, /*#__PURE__*/_jsx(HSPageViewTracker, {
      pathname: `${getRootUrl()}${pathname}`
    })]
  });
}